import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { SHAPE_FACTSHEET_BLUEPRINT } from '../../shapes'
import './styles.scss'
import { getComponentLabel } from '../../helper'

class SectionHeader extends PureComponent {
  render () {
    const sectionId = this.props.blueprint.id
    const section = this.props.factsheetBlueprint.factTree.sections[sectionId]
    const label = getComponentLabel(
      this.props.blueprint,
      section)
    return (
      <div className="section-header-title">{label}</div>
    )
  }
}

SectionHeader.propTypes = {
  blueprint: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired,
  factsheetBlueprint: PropTypes.shape(SHAPE_FACTSHEET_BLUEPRINT).isRequired
}
export default SectionHeader
